/**
 * Name printed on the "Server:" line of an offline kitchen ticket.
 *
 * Read from the signed-in user record the login page stores; there is no
 * server to ask. A dash rather than an empty string, so a slip never prints a
 * blank label.
 */
export function offlineServerName(): string {
  try {
    const raw = localStorage.getItem('pos_user')
    if (!raw) return '—'
    const u = JSON.parse(raw) as { username?: string }
    return u.username?.trim() || '—'
  } catch {
    return '—'
  }
}
